import { TeamModeState } from './types';

const initialTeamModeState: TeamModeState = {
  teamId: -1,
};

export default initialTeamModeState;
